var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled from 'styled-components';
import { fetchLogin } from '../requests/index';
import { Cross } from '../svgs';
import { useProfileState, useGlobalDispatch } from '../hooks';
export function RelianceLink(_a) {
    var children = _a.children, appName = _a.appName, className = _a.className;
    var _b = useState(false), showModal = _b[0], setShowModal = _b[1];
    var relianceAccounts = useProfileState().relianceAccounts;
    var dispatch = useGlobalDispatch();
    function ssoClick() {
        var id;
        if (relianceAccounts.length > 1) {
            setShowModal(true);
        }
        else {
            id = relianceAccounts[0].accountId;
            openSite(id);
        }
    }
    function openSite(id) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!id) return [3 /*break*/, 2];
                        dispatch({ type: 'set global loading', payload: true });
                        return [4 /*yield*/, fetchLogin(appName, id)];
                    case 1:
                        _a.sent();
                        dispatch({ type: 'set global loading', payload: false });
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function accountClick(id) {
        setShowModal(false);
        openSite(id);
    }
    return (_jsxs(React.Fragment, { children: [showModal ? (_jsx(Modal, { children: _jsxs("div", __assign({ className: 'select-container' }, { children: [_jsx(Cross, { onClick: function () { return setShowModal(false); } }, void 0),
                        _jsx("h5", { children: "Select an account" }, void 0),
                        _jsx("div", __assign({ className: 'account-container' }, { children: relianceAccounts.map(function (a) { return (_jsx("p", __assign({ onClick: function () { return accountClick(a.accountId); } }, { children: a.companyName }), void 0)); }) }), void 0)] }), void 0) }, void 0)) : null,
            _jsx(Container, __assign({ onClick: ssoClick, className: className }, { children: children }), void 0)] }, void 0));
}
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
var Modal = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99;\n\n  .select-container {\n    width: 90%;\n    max-width: 800px;\n    background: #ffffff;\n    height: 80%;\n    max-height: 500px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 3px;\n\n    svg {\n      height: 20px;\n      width: 20px;\n      align-self: flex-end;\n      margin: 30px 40px 0 0;\n      cursor: pointer;\n    }\n\n    h5 {\n      font-size: 2.6rem;\n      margin-bottom: 0;\n      font-weight: 200;\n      margin-top: 0;\n    }\n\n    .account-container {\n      height: 75%;\n      overflow-y: scroll;\n      width: 90%;\n\n      p {\n        font-size: 1.6rem;\n        width: 90%;\n        cursor: pointer;\n        padding: 5px 10px;\n\n        &:hover {\n          background: rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99;\n\n  .select-container {\n    width: 90%;\n    max-width: 800px;\n    background: #ffffff;\n    height: 80%;\n    max-height: 500px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 3px;\n\n    svg {\n      height: 20px;\n      width: 20px;\n      align-self: flex-end;\n      margin: 30px 40px 0 0;\n      cursor: pointer;\n    }\n\n    h5 {\n      font-size: 2.6rem;\n      margin-bottom: 0;\n      font-weight: 200;\n      margin-top: 0;\n    }\n\n    .account-container {\n      height: 75%;\n      overflow-y: scroll;\n      width: 90%;\n\n      p {\n        font-size: 1.6rem;\n        width: 90%;\n        cursor: pointer;\n        padding: 5px 10px;\n\n        &:hover {\n          background: rgba(0, 0, 0, 0.1);\n        }\n      }\n    }\n  }\n"])));
var templateObject_1, templateObject_2;
